/**
 * Mock data para compañías cliente
 */

import {
  Company,
  CompanyStatus,
  CompanyPlan,
  CompanyIndustry,
  CompaniesSummary,
} from '../entities/company';

export const MOCK_COMPANIES: Company[] = [
  {
    id: 'comp-001',
    name: 'Inmobiliaria Los Andes',
    logo: 'https://ui-avatars.com/api/?name=Inmobiliaria+Los+Andes&background=3b82f6&color=fff',
    industry: CompanyIndustry.REAL_ESTATE,
    status: CompanyStatus.ACTIVE,
    billing: {
      plan: CompanyPlan.ENTERPRISE,
      monthlyPrice: 890000,
      userSeats: 25,
      subscriptionStartDate: '2024-01-15',
      nextBillingDate: '2025-11-15',
      paymentMethod: 'bank_transfer',
      paymentStatus: 'current',
    },
    metrics: {
      activeUsers: 23,
      totalLeads: 1842,
      leadsThisMonth: 127,
      totalClients: 234,
      activeProjects: 8,
      lastLogin: '2025-10-08T09:15:00Z',
      totalInteractions: 5234,
    },
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2025-10-08T09:15:00Z',
    assignedOwlyUser: {
      id: 'owly-002',
      name: 'María González',
      role: 'OWLY_SALES',
    },
    enabledFeatures: ['crm', 'ai-assistant', 'analytics', 'omnichannel', 'advanced-reports'],
    internalNotes: 'Cliente premium. Renovación anual en enero. Interesados en módulo de entregas.',

    // Relaciones
    marketIds: ['market-co'], // Opera en Colombia
    projectIds: ['torre-verde'], // Torre Verde
  },
  {
    id: 'comp-002',
    name: 'Constructora Pacifico',
    logo: 'https://ui-avatars.com/api/?name=Constructora+Pacifico&background=10b981&color=fff',
    industry: CompanyIndustry.REAL_ESTATE,
    status: CompanyStatus.ACTIVE,
    billing: {
      plan: CompanyPlan.PROFESSIONAL,
      monthlyPrice: 490000,
      userSeats: 15,
      subscriptionStartDate: '2024-03-20',
      nextBillingDate: '2025-11-20',
      paymentMethod: 'credit_card',
      paymentStatus: 'current',
    },
    metrics: {
      activeUsers: 14,
      totalLeads: 967,
      leadsThisMonth: 89,
      totalClients: 156,
      activeProjects: 5,
      lastLogin: '2025-10-08T08:45:00Z',
      totalInteractions: 3421,
    },
    createdAt: '2024-03-20T14:30:00Z',
    updatedAt: '2025-10-08T08:45:00Z',
    assignedOwlyUser: {
      id: 'owly-002',
      name: 'María González',
      role: 'OWLY_SALES',
    },
    enabledFeatures: ['crm', 'ai-assistant', 'analytics'],
    internalNotes: 'Buen cliente. Crecimiento sostenido.',

    // Relaciones
    marketIds: ['market-co'], // Opera en Colombia
    projectIds: ['bosques-del-rio'], // Bosques del Río
  },
  {
    id: 'comp-003',
    name: 'Grupo Inmobiliario Sur',
    logo: 'https://ui-avatars.com/api/?name=Grupo+Inmobiliario+Sur&background=f59e0b&color=fff',
    industry: CompanyIndustry.REAL_ESTATE,
    status: CompanyStatus.TRIAL,
    billing: {
      plan: CompanyPlan.PROFESSIONAL,
      monthlyPrice: 0, // Trial
      userSeats: 10,
      subscriptionStartDate: '2025-10-01',
      nextBillingDate: '2025-11-01',
      paymentMethod: 'credit_card',
      paymentStatus: 'pending',
    },
    metrics: {
      activeUsers: 8,
      totalLeads: 234,
      leadsThisMonth: 234,
      totalClients: 12,
      activeProjects: 2,
      lastLogin: '2025-10-08T10:20:00Z',
      totalInteractions: 567,
    },
    createdAt: '2025-10-01T09:00:00Z',
    updatedAt: '2025-10-08T10:20:00Z',
    assignedOwlyUser: {
      id: 'owly-002',
      name: 'María González',
      role: 'OWLY_SALES',
    },
    enabledFeatures: ['crm', 'ai-assistant'],
    internalNotes: 'Trial de 30 días. Inmobiliaria nueva en expansión. Seguimiento cercano para conversión. Muy interesados en el producto.',

    // Relaciones
    marketIds: ['market-cr'], // Opera en Costa Rica
    projectIds: [], // Sin proyectos aún (en trial)
  },
  {
    id: 'comp-004',
    name: 'Constructora Valle Verde',
    logo: 'https://ui-avatars.com/api/?name=Constructora+Valle+Verde&background=ef4444&color=fff',
    industry: CompanyIndustry.REAL_ESTATE,
    status: CompanyStatus.ACTIVE,
    billing: {
      plan: CompanyPlan.PROFESSIONAL,
      monthlyPrice: 590000,
      userSeats: 20,
      subscriptionStartDate: '2024-06-10',
      nextBillingDate: '2025-11-10',
      paymentMethod: 'bank_transfer',
      paymentStatus: 'current',
    },
    metrics: {
      activeUsers: 18,
      totalLeads: 1523,
      leadsThisMonth: 156,
      totalClients: 289,
      activeProjects: 6,
      lastLogin: '2025-10-08T07:30:00Z',
      totalInteractions: 4532,
    },
    createdAt: '2024-06-10T11:00:00Z',
    updatedAt: '2025-10-08T07:30:00Z',
    assignedOwlyUser: {
      id: 'owly-003',
      name: 'Carlos Ruiz',
      role: 'OWLY_SUPPORT',
    },
    enabledFeatures: ['crm', 'ai-assistant', 'analytics', 'omnichannel'],
    internalNotes: 'Constructora con alto volumen de leads. Proyectos residenciales de interés social. Uso intensivo de omnicanal.',

    // Relaciones
    marketIds: ['market-mx'], // Opera en México
    projectIds: [], // Sin proyectos registrados aún en OWLY
  },
  {
    id: 'comp-005',
    name: 'Propiedades Premium',
    logo: 'https://ui-avatars.com/api/?name=Propiedades+Premium&background=8b5cf6&color=fff',
    industry: CompanyIndustry.REAL_ESTATE,
    status: CompanyStatus.ACTIVE,
    billing: {
      plan: CompanyPlan.STARTER,
      monthlyPrice: 190000,
      userSeats: 5,
      subscriptionStartDate: '2024-08-15',
      nextBillingDate: '2025-11-15',
      paymentMethod: 'credit_card',
      paymentStatus: 'current',
    },
    metrics: {
      activeUsers: 5,
      totalLeads: 423,
      leadsThisMonth: 45,
      totalClients: 67,
      activeProjects: 3,
      lastLogin: '2025-10-08T09:00:00Z',
      totalInteractions: 1234,
    },
    createdAt: '2024-08-15T16:00:00Z',
    updatedAt: '2025-10-08T09:00:00Z',
    assignedOwlyUser: {
      id: 'owly-002',
      name: 'María González',
      role: 'OWLY_SALES',
    },
    enabledFeatures: ['crm', 'ai-assistant'],
    internalNotes: 'Cliente pequeño pero constante. Potencial para upgrade a Professional.',

    // Relaciones
    marketIds: ['market-co'], // Opera en Colombia
    projectIds: ['ciudad-jardin'], // Ciudad Jardín
  },
  {
    id: 'comp-006',
    name: 'Inversiones del Norte',
    logo: 'https://ui-avatars.com/api/?name=Inversiones+del+Norte&background=06b6d4&color=fff',
    industry: CompanyIndustry.REAL_ESTATE,
    status: CompanyStatus.SUSPENDED,
    billing: {
      plan: CompanyPlan.PROFESSIONAL,
      monthlyPrice: 490000,
      userSeats: 12,
      subscriptionStartDate: '2024-04-05',
      nextBillingDate: '2025-10-05',
      paymentMethod: 'bank_transfer',
      paymentStatus: 'overdue',
      outstandingBalance: 980000,
    },
    metrics: {
      activeUsers: 0,
      totalLeads: 856,
      leadsThisMonth: 0,
      totalClients: 134,
      activeProjects: 4,
      lastLogin: '2025-09-20T14:30:00Z',
      totalInteractions: 2876,
    },
    createdAt: '2024-04-05T10:00:00Z',
    updatedAt: '2025-09-25T10:00:00Z',
    assignedOwlyUser: {
      id: 'owly-003',
      name: 'Carlos Ruiz',
      role: 'OWLY_SUPPORT',
    },
    enabledFeatures: ['crm', 'ai-assistant', 'analytics'],
    internalNotes: 'URGENTE: Cuenta suspendida por falta de pago. 2 facturas pendientes. Seguimiento de cobranza.',

    // Relaciones
    marketIds: ['market-do'], // Opera en República Dominicana
    projectIds: [], // Sin proyectos registrados
  },
  {
    id: 'comp-007',
    name: 'Desarrollos Urbanos SpA',
    logo: 'https://ui-avatars.com/api/?name=Desarrollos+Urbanos&background=14b8a6&color=fff',
    industry: CompanyIndustry.REAL_ESTATE,
    status: CompanyStatus.ACTIVE,
    billing: {
      plan: CompanyPlan.ENTERPRISE,
      monthlyPrice: 1200000,
      userSeats: 35,
      subscriptionStartDate: '2023-11-20',
      nextBillingDate: '2025-11-20',
      paymentMethod: 'bank_transfer',
      paymentStatus: 'current',
    },
    metrics: {
      activeUsers: 32,
      totalLeads: 3421,
      leadsThisMonth: 234,
      totalClients: 456,
      activeProjects: 12,
      lastLogin: '2025-10-08T10:30:00Z',
      totalInteractions: 8765,
    },
    createdAt: '2023-11-20T09:00:00Z',
    updatedAt: '2025-10-08T10:30:00Z',
    assignedOwlyUser: {
      id: 'owly-001',
      name: 'Roberto Silva',
      role: 'OWLY_ADMIN',
    },
    enabledFeatures: [
      'crm',
      'ai-assistant',
      'analytics',
      'omnichannel',
      'advanced-reports',
      'custom-integrations',
      'api-access',
    ],
    internalNotes: 'Cliente Enterprise de mayor valor. Cuenta clave. Renovación anual en noviembre.',

    // Relaciones
    marketIds: ['market-co', 'market-pe', 'market-mx'], // Opera en múltiples mercados
    projectIds: [], // Tiene muchos proyectos pero no están registrados aún
  },
];


export const MOCK_COMPANIES_SUMMARY: CompaniesSummary = {
  total: 7,
  active: 5,
  trial: 1,
  suspended: 1,
  monthlyRecurringRevenue: 3850000,
  annualRecurringRevenue: 46200000,
  growthRate: 12.5,
  newCompaniesThisMonth: 1,
  churnRate: 2.3,
};

/**
 * Helper para obtener una compañía por ID
 */
export function getCompanyById(id: string): Company | undefined {
  return MOCK_COMPANIES.find((company) => company.id === id);
}

/**
 * Helper para obtener compañías por estado
 */
export function getCompaniesByStatus(status: CompanyStatus): Company[] {
  return MOCK_COMPANIES.filter((company) => company.status === status);
}

/**
 * Helper para obtener compañías asignadas a un usuario OWLY
 */
export function getCompaniesByOwlyUser(owlyUserId: string): Company[] {
  return MOCK_COMPANIES.filter(
    (company) => company.assignedOwlyUser?.id === owlyUserId
  );
}
